module.exports = __webpack_public_path__ + "img/visualizar-monitoramento-socio-ambiental.5dfb5973.svg";